<template>
  <van-popup
    v-model="showiIntervieweePopup"
    round
    position="bottom"
    :style="{ height: '80%' }"
  >
    <div class="interviewee-dialog">
      <van-search
        v-model="searchName"
        show-action
        placeholder="请输入完整的姓名"
        @search="onSearch"
        @clear="searchNameList = []"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div v-if="searchNameList.length > 0">
        <div class="interviewee-list_title" style="color: #999; font-size: .85rem">
          <div>搜索结果</div>
          <van-icon name="delete" style="color: #999; font-size: .85rem" @click="searchNameList = []" /> 
        </div>
        <div class="interviewee-list">
          <div
            class="interviewee-item"
            @click="clickIntervieweeItem(item, index)"
            v-for="(item, index) in searchNameList"
            :class="{ active: intervieweeIndex == index }"
            :key="item.id"
          >
            {{ item.info }}
          </div>
        </div>
      </div>

      <div v-if="searchNameList.length <= 0 && hisList.length > 0">
        <div style="color: #999; font-size: 0.75rem">历史搜索</div>
        <div class="interviewee-list">
          <div
            class="interviewee-item"
            @click="clickIntervieweeItem(item, index, 'his')"
            v-for="(item, index) in hisList"
            :class="{ active: intervieweeHisIndex == index }"
            :key="item.id"
          >
            {{ item.info }}
          </div>
        </div>
      </div>

      <div class="btn-wrap">
        <van-row class="btn-group" gutter="20">
          <van-col :span="24" style="text-align: right">
            <van-button
              type="default"
              block
              @click="showiIntervieweePopup = false"
            >
              取消</van-button
            >
          </van-col>
          <!-- <van-col span="12" v-if="select">
            <van-button type="info" block @click="handleAddPerson"
              >确认</van-button
            >
          </van-col> -->
        </van-row>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: ['pageType'],

  data() {
    return {
      showiIntervieweePopup: false,
      searchName: '',
      searchNameList: [],
      intervieweeIndex: -1,
      hisList: [],
      intervieweeHisIndex: -1,
      // select: false,
      item: {},
    }
  },
  computed: {
    getSchoolId() {
      let schoolId
      if (this.pageType == 'fk') {
        schoolId = sessionStorage.getItem('qrcodeSchoolId')
      }
      if (this.pageType == 'teacher') {
        schoolId = JSON.parse(localStorage.getItem('userInfo')).schoolId
      }
      if (this.pageType == 'student') {
        schoolId = JSON.parse(localStorage.getItem('userInfo'))
          .schoolId
      }
      return schoolId
    },
  },
  mounted() {
    this.getHistoryDept()
  },
  methods: {
    async getUserDept() {
      this.item = {}
      this.intervieweeIndex = -1
      this.intervieweeHisIndex = -1
      if (!this.searchName) {
        this.$toast('请输入完整的姓名')
        return false
      }
      console.log('this.pageType',this.pageType)
      const { data, code } = await this.$https.getUserDept({
        name: this.searchName,
        schoolId: this.getSchoolId,
      })

      if (data && data.length == 0 && code === 200) {
        this.$toast('搜索不到当前人员，请检查后重试')
        this.searchNameList = []
        return false
      }
      if (code !== 200) {
        this.$toast('搜索不到当前人员，请检查后重试')
        this.searchNameList = []
        return false
      }
      console.log(data)
      this.searchNameList = data.map((item) => {
        item.info = `${item.name}${item.deptName ? '-' + item.deptName : ''}`
        console.log(item)
        return item
      })
    },
    onSearch() {
      console.log('123456-----------------------')
      this.getUserDept()
    },
    clickIntervieweeItem(item, index, type) {
      console.log('获取点击选中的值',item)
      this.item = item
      if (type) {
        this.intervieweeHisIndex = index
      } else {
        this.intervieweeIndex = index
      }
      // this.select = true
      // item.info = `${item.name}${item.deptName ? '-' + item.deptName : ''}`
      const { id, name, deptName } = item

      this.$emit('selectItem', { ...item })
      this.showiIntervieweePopup = false
    },

    async getHistoryDept() {
      const { data, code } = await this.$https.getHistoryDept({
        userId: JSON.parse(localStorage.getItem('userInfo')).loginId,
      })
      if (code !== 200) {
        this.hisList = []
        return false
      }
      console.log('获取data和hisList',data,this.hisList)
      
      if (data) {
         this.hisList = data.map((item) => {
        item.info = `${item.name}${item.deptName ? '-' + item.deptName : ''}`
        return item
        })
      }
     
    },
    // handleAddPerson() {

    // },
  },
}
</script>

<style lang="scss" scoped>
.interviewee-dialog {
  padding: 1rem  1rem 1rem;
  
  position: relative;
  height: 100%;
  .interviewee-list_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .interviewee-list {
    margin-bottom: 3rem;
    display: flex;
    padding: 10px 12px;
    flex-wrap: wrap;
    .interviewee-item {
      padding: 0.2rem 0.5rem;
      font-size: 0.9375rem;
      margin-bottom: 1rem;
      color: #171717;
      background: rgba(244, 244, 244, 1);
      border-radius: 0.3125rem;
      margin-right: 0.5rem;
      border: 1px solid transparent;
      &.active {
        border: 1px solid rgba(22, 118, 254, 1);
        background: #fff;
      }
    }
  }
  .btn-wrap {
    position: fixed;
    bottom: 20px;
    left: 1.8rem; 
    right: 2.2rem;
    height: 4rem;
    bottom: 0;
    background-color:#fff;
  }
  .btn-group {
    box-sizing: border-box;
  }
}
</style>
